
import Vue from "vue";
import { mapMutations, mapActions } from "vuex";
import EventDetails from "~/components/EventShipping/EventDetails.vue";
import ShipSteps from "~/components/ship/ShipSteps.vue";
import Event from "~/entities/Event";

export default Vue.extend({
  components: { EventDetails },
  layout: "WithServices",

  data() {
    return {
      isLoading: true as boolean,
      selectedEvent: {} as Event,
      parsedBB: undefined as any,
      flushCaller: "events-event",
    };
  },
  async asyncData({ params, store, app, error }) {
    store.commit("eventShipping/setEventName", params.event);
    let eventData = await store
      .dispatch("eventShipping/getEventByUrl")
      .then((res) => {
        if (res) {
          return res[0].value;
        } else {
          error({
            statusCode: 404,
            message: `Invalid route`,
          });
          return false;
        }
      });
    return {
      eventData: eventData,
    };
  },
  head() {
    return {
      title: (this as any).eventData?.name
        ? (this as any).eventData.name +
          " " +
          new Date((this as any).eventData.startDate).getFullYear() +
          " - " +
          (this as any).eventData.city +
          ", " +
          (this as any).eventData.state +
          " - BikeFlights.com"
        : "Bikeflights.com",
      meta: [
        {
          hid: "eventshippingdetails",
          name: "eventshippingdetails",
          content:
            "Ship your bike, wheels and gear with confidence to " +
            (this as any).eventData.name +
            " for " +
            (this as any).eventData.state +
            ". Get costs and ship today!.",
        },
      ],
    };
  },
  methods: {
    ...mapMutations({
      flushShipStore: "ship/flush",
      flushPaymentStore: "payment/flush",
    }),
    ...mapActions({
      clearActiveNotices: "errorsBag/clearActiveNotices",
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // access to component public instance via `vm`
      if (vm) {
        if (from && from.name == "bicycleshops") {
          (vm as any).flushCaller = "bicycleshops";
        } else {
          if (from && from.name !== "events-event") {
            (vm as any).clearActiveNotices();
          }
          (vm as any).flushCaller = "events-event";
        }
        (vm as any).flushShipStore((vm as any).flushCaller); // call payment flusher too
        (vm as any).flushPaymentStore((vm as any).flushCaller);
      }
    });
  },
});
